<div class="phrase-main">

  <div class="prestamo-and-title">
    <!-- <prestamo-bar
      [icono]="icons.money"
      [texto]="'Préstamo para negocios'">
    </prestamo-bar> -->
    <div>
      <span>Haz que tu negocio crezca</span>
      <span class="today-text"> HOY</span>
    </div>
  </div>

  <button-credito
    [texto]="'Solicitar crédito'"
    [icono]="icons.buttonCircle"
  ></button-credito>

</div>
